module.exports = __webpack_public_path__ + "static/mobility_mobile-c09f8ca856f0aba7efea1122bf526d91.jpg";